import React from 'react';
import { Text } from '@admitkard/ccl/Text';
import { theme } from '@admitkard/ccl/style';
import { Button } from '@admitkard/ccl/Button';
import Link from 'next/link';
import { Img } from '@admitkard/ccl/Img';
import { env } from '@admitkard/uiutils/env';

const styles =`
  .product-pricing_container {
    background-image: url(${env.getAssetUrl('images/pricing_page_background.png')});
    background-size: cover;
  }
  .product-pricing_title-text {
    font-size: ${theme.fontSize.xl};
    margin-top: 2rem;
    margin-bottom: ${theme.spacingOld(5)};
  }
  .product-pricing_description-text {
    font-size: ${theme.fontSize.xs};
    margin-bottom: 2rem;
  }
  .product-pricing_select-wrapper {
    width: 13.75rem;
    min-height: 11.875rem;
    box-shadow: ${theme.shadows[4]};
    background-color: ${theme.palette.common.white};
    border-radius: ${theme.shape.borderRadius};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: ${theme.spacingOld(5)} 0;
  }
  .product-pricing_select-wrapper-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: ${theme.spacingOld(5)};
  }
  .product-pricing_select-wrapper:first-child {
    margin-bottom: ${theme.spacingOld(6)};
  }
  .product-pricing_select-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: ${theme.spacingOld(7)};
  }
  .product-pricing_select-wrapper img {
    width: 120px;
    height: auto;
  }
  .product-pricing_select-wrapper-title {
    margin-bottom: ${theme.spacingOld(5)};
  }
  .product-pricing_select-text-description {
    font-size: ${theme.fontSize.xxs};
    padding: 0 ${theme.spacingOld(5)};
    margin-top: 0.5rem;
  }
  @media only screen and (min-width: 768px) {
    .product-pricing_text-container {
      width: 50%;
      margin: 0 auto;
    }
    .product-pricing_title-text {
      font-size: ${theme.fontSize.xxxl};
      margin-top: 4rem;
      margin-bottom: ${theme.spacingOld(3)};
    }
    .product-pricing_description-text {
      font-size: ${theme.fontSize.m};
    }
    .product-pricing_select-container {
      flex-direction: row;
      justify-content: space-around;
    }
    .product-pricing_select-wrapper {
      width: 29.875rem;
      max-height: 23.9375rem;
      padding: ${theme.spacingOld(6)} 0;
    }
    .product-pricing_select-wrapper:first-child {
      margin-bottom: 0;
    }
    .product-pricing_select-wrapper-title {
      font-size: ${theme.fontSize.xl};
      margin-bottom: ${theme.spacingOld(5)};
    }
    .product-pricing_select-wrapper img {
      width: unset;
      height: 13rem;
    }
    .product-pricing_select-text-description {
      letter-spacing: 1.5px;
      font-size: ${theme.fontSize.l};
      min-height: 3.25rem;
    }
  }
`;

export const ProductAndPricing: React.FunctionComponent = () => {
  return <div className="container product-pricing_container">
    <div className="product-pricing_text-container">
      <Text className='product-pricing_title-text' display='block' align='center' weight='bold'>
        What is the next step of your career?
      </Text>
      <Text className='product-pricing_description-text' display='block' align='center' lightness={9}>
        Select a category that&apos;s right for your study abroad needs
      </Text>
    </div>
    <div className='product-pricing_select-container'>
      <div className='product-pricing_select-wrapper'>
        <div className='product-pricing_select-wrapper-container'>
          <Text className='product-pricing_select-wrapper-title' weight='bold' display='block'>
            UG Admissions
          </Text>
          <div>
            <Img src="images/pricing_ug.png" alt='UG image' />
          </div>
          <Text display='block' align='center' className="product-pricing_select-text-description">
            Are you a school student?
          </Text>
        </div>
        <Link href='/company/product-pricing-description-policy/ug'>
          <Button variant='contained' color='primary'>
            View Plan
          </Button>
        </Link>
      </div>
      <div className='product-pricing_select-wrapper'>
        <div className='product-pricing_select-wrapper-container'>
          <Text className='product-pricing_select-wrapper-title' weight='bold' display='block'>
            PG Admissions
          </Text>
          <div>
            <Img src="images/pricing_pg.png" alt='PG image' />
          </div>
          <Text display='block' align='center' className="product-pricing_select-text-description">
            Are you a university student or a working professional?
          </Text>
        </div>
        <Link href='/company/product-pricing-description-policy/pg'>
          <Button variant='contained' color='primary'>
            View Plan
          </Button>
        </Link>
      </div>
    </div>
    <style>{styles}</style>
  </div>;
};
